import { render, staticRenderFns } from "./RPNotifications.vue?vue&type=template&id=bb0c23de&"
import script from "./RPNotifications.vue?vue&type=script&lang=js&"
export * from "./RPNotifications.vue?vue&type=script&lang=js&"
import style0 from "./RPNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports